import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const acfund = [
  {
    path: "/acfund",
    name: "acfund",
    component: () => import("../accumulationfund/index"),
    meta: {
      title: "住房公积金",
      keepAlive: true,
    },
  },
  {
    path: "/acfund/base_info",
    name: "base_info",
    component: () => import("acfund/base_info"),
    meta: {
      title: "公积金账户基本信息",
    },
  },
  {
    path: "/acfund/credit_info",
    name: "credit_info",
    component: () => import("acfund/credit_info"),
    meta: {
      title: "贷款账户信息",
    },
  },
  {
    path: "/acfund/repayment_info",
    name: "repayment_info",
    component: () => import("acfund/repayment_info"),
    meta: {
      title: "贷款还款明细",
    },
  },
  {
    path: "/acfund/account_details",
    name: "account_details",
    component: () => import("acfund/account_details"),
    meta: {
      title: "账户明细信息",
    },
  },
  {
    path: "/whereami",
    name: "whereami",
    component: () => import("../whereami/index"),
    meta: {
      title: "我的位置",
    },
  },
  {
    path: "/areaRediect",
    name: "areaRediect",
    component: () => import("../area/areaRediect"),
    meta: {
      title: "十全十美",
    },
  },
  {
    path: "/getarea",
    name: "getarea",
    component: () => import("../area/index"),
    meta: {
      title: "十全十美",
    },
  },
  {
    path: "/gatewayChoose",
    name: "gatewayChoose",
    component: () => import("../area/gatewayChoose"),
    meta: {
      title: "门户选择",
    },
  },
  {
    path: "/area",
    name: "area",
    component: () => import("../area/rediect"),
    meta: {
      title: "十全十美",
    },
  },
  {
    path: "/areaselect",
    name: "areaselect",
    component: () => import("../area/area"),
    meta: {
      title: "十全十美",
    },
  },
  {
    path: "/customer",
    name: "customer",
    component: () => import("../customer/index"),
    meta: {
      title: "智能客服",
    },
  },
];

const progress = [
  {
    path: "/progress",
    name: "progress",
    component: () =>
      import(/* webpackChunkName: "progress" */ "../progress/index"),
    meta: {
      title: "办事进度",
    },
  },
  {
    path: "/progressDetails",
    name: "progressDetails",
    component: () =>
      import(/* webpackChunkName: "progressDetails" */ "../progress/details"),
    meta: {
      title: "进度详情",
    },
  },
  {
    path: "/guide/index",
    name: "guide",
    component: () => import(/* webpackChunkName: "guide" */ "../guide/index"),
    meta: {
      title: "办事指南",
    },
  },
  {
    path: "/guide/guidemain",
    name: "guidemain",
    component: () =>
      import(/* webpackChunkName: "guide" */ "../guide/guidemain"),
    meta: {
      title: "办事",
      background: "gray",
    },
  },
  {
    path: "/guide/guidemainnew",
    name: "guidemainnew",
    component: () =>
      import(/* webpackChunkName: "guide" */ "../guide/guidemainNew"),
    meta: {
      title: "苏服办·苏周到",
      background: "gray",
    },
  },
  {
    path: "/guide/affairs",
    name: "guideAffairs",
    component: () => import("../guide/affairs"),
    meta: {
      title: "　",
      background: "gray",
    },
  },
  {
    path: "/guide/guidetasklist",
    name: "guidetasklist",
    component: () =>
      import(/* webpackChunkName: "guide" */ "../guide/guidetasklist"),
  },
  {
    path: "/guide/guidelist",
    name: "guidelist",
    component: () =>
      import(/* webpackChunkName: "guidelist" */ "../guide/guidelist"),
    meta: {
      title: "办事指南",
    },
  },
  {
    path: "/guide/search",
    name: "guidesearch",
    component: () =>
      import(/* webpackChunkName: "guidelist" */ "../guide/search"),
  },
  {
    path: "/guidedetails",
    name: "guidedetails",
    component: () =>
      import(/* webpackChunkName: "guidedetails" */ "../guide/guidedetails"),
    meta: {
      title: "办事指南",
    },
  },
  {
    path: "/guidehandle",
    name: "guidehandle",
    component: () =>
      import(/* webpackChunkName: "guidehandle" */ "../guide/handle"),
    meta: {
      title: "预约办理",
    },
  },
  {
    path: "/guide/result",
    name: "guideresult",
    component: () =>
      import(/* webpackChunkName: "guideresult" */ "../guide/result"),
    meta: {
      title: "预约结果",
    },
  },
  {
    path: "/guide/declare",
    name: "guide-declare",
    component: () => import("../guide/declare"),
    meta: {
      title: "在线申报",
    },
  },
  {
    path: "/guide/progress",
    name: "guide-progress",
    component: () => import("../guide/progress"),
    meta: {
      title: "办事进度",
    },
  },
  {
    path: "/guide/detail",
    name: "guide-detail",
    component: () => import("../guide/detail"),
    meta: {
      title: "进度详情",
    },
  },
  {
    path: "/guide/myOrder",
    name: "guide-myOrder",
    component: () => import("../guide/myOrder"),
    meta: {
      title: "我的预约",
      background: "gray",
    },
  },
  {
    path: "/guide/calendar",
    name: "calendar",
    component: () => import("../guide/calendar"),
    meta: {
      title: "我的预约",
    },
  },
  {
    path: "/complaints",
    name: "complaints",
    component: () =>
      import(/* webpackChunkName: "complaints" */ "../complaints/index"),
    meta: {
      title: "用户申诉",
    },
  },
  {
    path: "/feedback",
    name: "feedback",
    component: () =>
      import(/* webpackChunkName: "feedback" */ "../feedback/index"),
    meta: {
      title: "使用反馈",
    },
  },
  {
    path: "/feedback/service",
    name: "feedbackservice",
    component: () =>
      import(/* webpackChunkName: "feedback" */ "../feedback/service"),
    meta: {
      title: "服务反馈",
    },
  },
  {
    path: "/feedback/history",
    name: "feedbackhistory",
    component: () =>
      import(/* webpackChunkName: "feedback" */ "../feedback/history"),
    meta: {
      title: "反馈历史",
      background: "gray",
    },
  },
  {
    path: "/cancellation",
    name: "cancellation",
    component: () =>
      import(/* webpackChunkName: "cancellation" */ "../cancellation/index"),
    meta: {
      title: "账号注销",
    },
  },
  {
    path: "/func-intro",
    name: "funcIntro",
    component: () =>
      import(/* webpackChunkName: "funcIntro" */ "../func-intro/index"),
    meta: {
      title: "功能介绍",
    },
  },
  {
    path: "/agreement-policy",
    name: "agreementPolicy",
    component: () =>
      import(
        /* webpackChunkName: "agreementPolicy" */ "../agreement-policy/index"
      ),
    meta: {
      title: "政策和协议",
    },
  },
  {
    path: "/manual",
    name: "manual",
    component: () =>
      import(
        /* webpackChunkName: "agreementPolicy" */ "../agreement-policy/userhandbook"
      ),
    meta: {
      title: "苏周到用户手册",
    },
  },
  {
    path: "/user-policy",
    name: "userPolicy",
    component: () =>
      import(
        /* webpackChunkName: "userPolicy" */ "../agreement-policy/RenzhengXieyi"
      ),
    meta: {
      title: "用户认证协议",
    },
  },
  {
    path: "/service-policy",
    name: "ServicePolicy",
    component: () =>
      import(
        /* webpackChunkName: "userPolicy" */ "../agreement-policy/FuwuXieyi"
      ),
    meta: {
      title: "",
    },
  },
  {
    path: "/auth-policy",
    name: "AuthPolicy",
    component: () =>
      import(
        /* webpackChunkName: "userPolicy" */ "../agreement-policy/RenzhengXieyi"
      ),
    meta: {
      title: "",
    },
  },
  {
    path: "/private-policy",
    name: "PrivatePolicy",
    component: () =>
      import(
        /* webpackChunkName: "userPolicy" */ "../agreement-policy/YinsiXieyi"
      ),
    meta: {
      title: "",
    },
  },
  {
    path: "/private-children",
    name: "PrivateChildren",
    component: () =>
      import(
        /* webpackChunkName: "userPolicy" */ "../agreement-policy/YinsiChildren"
      ),
    meta: {
      title: "",
    },
  },
  {
    path: "/yibao-xieyi",
    name: "YibaoXieyi",
    component: () =>
      import(
        /* webpackChunkName: "userPolicy" */ "../agreement-policy/YibaoXieyi"
      ),
    meta: {
      title: "",
    },
  },
  {
    path: "/renlian-xuzhi",
    name: "RenlianXuzhi",
    component: () =>
      import(
        /* webpackChunkName: "userPolicy" */ "../agreement-policy/RenlianXuzhi"
      ),
    meta: {
      title: "",
    },
  },
  {
    path: "/blood/regulation",
    name: "customer",
    component: () => import("../blood/regulation"),
    meta: {
      title: "献血法规",
    },
  },
  {
    path: "/blood/instruction",
    name: "customer",
    component: () => import("../blood/instruction"),
    meta: {
      title: "注意事项",
    },
  },
  {
    path: "/blood/knowledge",
    name: "customer",
    component: () => import("../blood/knowledge"),
    meta: {
      title: "献血常识",
    },
  },
  {
    path: "/vaccine/index",
    name: "vaccine",
    component: () => import("../vaccine/indexNew"),
    meta: {
      title: "疫苗接种记录",
    },
  },
];

const my = [
  {
    path: "/mycomment",
    name: "mycomment",
    component: () => import("../my/mycomment"),
    meta: {
      title: "我的评论",
    },
  },
  {
    path: "/wgcomment",
    name: "wgcomment",
    component: () => import("../comment/list.vue"),
    meta: {
      title: "评论列表",
    },
  },
  {
    path: "/mycollect",
    name: "mycollect",
    component: () => import("../my/mycollect"),
    meta: {
      title: "我的收藏",
    },
  },
  {
    path: "/myjifen",
    name: "myjifen",
    component: () => import("../my/jifen"),
    // component: () => import('../my/jifen-back'),
    meta: {
      title: "我的积分",
    },
  },
];

const zh = [
  {
    path: "/library/search",
    name: "search",
    component: () => import("../library/search"),
    meta: {
      title: "图书搜索",
    },
  },
  {
    path: "/library/search-result",
    name: "result",
    component: () => import("../library/searchResult"),
    meta: {
      title: "搜索结果",
    },
  },
  {
    path: "/library/detail",
    name: "detail",
    component: () => import("../library/detail"),
    meta: {
      title: "图书详情",
    },
  },
  {
    path: "/library/order",
    name: "order",
    component: () => import("../library/order"),
    meta: {
      title: "提交订单",
    },
  },
  {
    path: "/library/findnewbook",
    name: "findnewbook",
    component: () => import("../library/findnewbook"),
    meta: {
      title: "苏州图书馆",
      keepAlive: true,
    },
  },
  {
    path: "/book-collection-point",
    name: "bookCollectionPoint",
    component: () => import("../library/bookCollectionPoint"),
    meta: {
      title: "取书点",
    },
  },
  {
    path: "/book-point-list",
    name: "bookPointList",
    component: () => import("../library/bookPointList"),
    meta: {
      title: "图书馆列表",
    },
  },
  {
    path: "/borrowing-at-present",
    name: "borrowingAtPresent",
    component: () => import("../library/borrowingAtPresent"),
    meta: {
      title: "当前借阅",
    },
  },
  {
    path: "/bus/home",
    name: "bus_home",
    component: () => import("../bus/home"),
    meta: {
      title: "实时公交查询",
      keepAlive: true,
    },
  },
  {
    path: "/bus/site-detail",
    name: "site_detail",
    component: () => import("../bus/siteDetail"),
    meta: {
      title: "站点详情",
    },
  },
  {
    path: "/bus/fault-repair",
    name: "fault_repair",
    component: () => import("../bus/faultRepair"),
    meta: {
      title: "线路纠错或故障报修",
    },
  },
  {
    path: "/bus/search",
    name: "bus_search",
    component: () => import("../bus/search"),
    meta: {
      title: "搜索",
    },
  },
  {
    path: "/bus/line-detail",
    name: "line-detail",
    component: () => import("../bus/line-detail"),
    meta: {
      title: "线路详情",
    },
  },
  {
    path: "/bus/map-detail",
    name: "map-detail",
    component: () => import("../bus/map-detail"),
    meta: {
      title: "地图详情",
    },
  },
  {
    path: "/sport/venue-list",
    name: "venue-list",
    component: () => import("../sport/venueList"),
    meta: {
      title: "体育场馆",
      keepAlive: true,
    },
  },
  {
    path: "/sport/venue-details",
    name: "venue-details",
    component: () => import("../sport/venueDetails"),
    meta: {
      title: "场馆详情",
    },
  },
  {
    path: "/sport/place-order",
    name: "place-order",
    component: () => import("../sport/placeOrder"),
    meta: {
      title: "提交订单",
    },
  },
  {
    path: "/sport/order-success",
    name: "order-success",
    component: () => import("../sport/orderSuccess"),
    meta: {
      title: "预定成功",
    },
  },
  {
    path: "/sport/order-details",
    name: "order-details",
    component: () => import("../sport/orderDetails"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/sport/swim-venue-list",
    name: "swim-venue-list",
    component: () => import("../sport/swimVenueList"),
    meta: {
      title: "游泳馆列表",
    },
  },
  {
    path: "/sport/order-list",
    name: "order-list",
    component: () => import("../sport/orderList"),
    meta: {
      title: "订单列表",
    },
  },
  {
    path: "/appointment/nuclearList",
    name: "nuclearList",
    component: () => import("../appointment/nuclearList"),
    meta: {
      title: "核酸检测",
    },
  },
  {
    path: "/appointment/feverlist",
    name: "feverlist",
    component: () => import("../appointment/feverlist"),
    meta: {
      title: "发热门诊",
    },
  },
  {
    path: "/appointment/nuclearConfirm",
    name: "nuclearConfirm",
    component: () => import("../appointment/nuclearConfirm"),
    meta: {
      title: "核酸检测“愿检尽检”承诺书",
    },
  },
  {
    path: "/appointment/select-hospital",
    name: "select-hospital",
    component: () => import("../appointment/selectHospital"),
    meta: {
      title: "选择医院",
    },
  },
  {
    path: "/appointment/nucleicList",
    name: "nucleicList",
    component: () => import("../appointment/nucleicList"),
    meta: {
      title: "选择医院",
    },
  },
  {
    path: "/appointment/nucleic",
    name: "nucleic",
    component: () => import("../appointment/nucleic"),
    meta: {
      title: "核酸检测",
    },
  },
  {
    path: "/appointment/select-department",
    name: "select-department",
    component: () => import("../appointment/selectDepartment"),
    meta: {
      title: "选择科室",
    },
  },
  {
    path: "/appointment/expert-detail",
    name: "expert-detail",
    component: () => import("../appointment/expertDetail"),
    meta: {
      title: "专家详情",
      keepAlive: true,
    },
  },
  {
    path: "/appointment/checkup-report",
    name: "checkup-report",
    component: () => import("../appointment/checkupReport"),
    meta: {
      title: "体检报告",
    },
  },
  {
    path: "/appointment/checkup-search",
    name: "checkup-search",
    component: () => import("../appointment/checkupSearch"),
    meta: {
      title: "健康体检查询",
    },
  },
  {
    path: "/appointment/nuclearreportlist",
    name: "nuclearreportlist",
    component: () => import("../appointment/nuclearreportlist"),
    meta: {
      title: "核酸检测结果查询",
    },
  },
  {
    path: "/appointment/nuclearreportResult",
    name: "nuclearreportResult",
    component: () => import("../appointment/nuclearreportResult2"),
    meta: {
      title: "核酸检测结果查询",
      background: "gray",
    },
  },
  {
    path: "/appointment/nuclearreportResultENG",
    name: "nuclearreportResultENG",
    component: () => import("../appointment/eng/nuclearreportResult-eng"),
    meta: {
      title: "Check for Nucleic Acid Testing Results",
    },
  },
  {
    path: "/appointment/nuclearENG",
    name: "nuclearENG",
    component: () => import("../appointment/eng/nuclearIndex"),
    meta: {
      title: "Information about Nucleic Acid Testing",
      background: "gray",
      keepAlive: true,
    },
  },
  {
    path: "/appointment/nuclearGAT",
    name: "nuclearGAT",
    component: () => import("../appointment/gat/nuclearIndex"),
    meta: {
      title: "核酸检测情况查询",
      background: "gray",
      keepAlive: true,
    },
  },
  {
    path: "/appointment/nuclearreportdetail",
    name: "nuclearreportdetail",
    component: () => import("../appointment/nuclearreportdetail"),
    meta: {
      title: "核酸检测结果查询",
      background: "gray",
    },
  },
  {
    path: "/appointment/nuclearreportdetail2",
    name: "nuclearreportdetail2",
    component: () => import("../appointment/nuclearreportdetail2"),
    meta: {
      title: "核酸检测采样记录查询",
      background: "gray",
    },
  },
  {
    path: "/appointment/nuclearreportdetail2ENG",
    name: "nuclearreportdetail2ENG",
    component: () => import("../appointment/eng/nuclearreportdetail2-eng"),
    meta: {
      title: "Check for Nucleic Acid Records",
      background: "gray",
    },
  },
  {
    path: "/appointment/nuclearreportNodata",
    name: "nuclearreportNodata",
    component: () => import("../appointment/nuclearreportNodata"),
    meta: {
      title: "核酸检测采样记录查询",
      background: "gray",
    },
  },
  {
    path: "/appointment/nuclearreportNodataENG",
    name: "nuclearreportNodataENG",
    component: () => import("../appointment/eng/nuclearreportNodata"),
    meta: {
      title: "Check for Nucleic Acid Records",
      background: "gray",
    },
  },
  {
    path: "/appointment/nuclearreportResultNodata",
    name: "nuclearreportResultNodata",
    component: () => import("../appointment/nuclearreportResultNodata"),
    meta: {
      title: "核酸检测结果查询",
      background: "gray",
    },
  },
  {
    path: "/appointment/nuclearreportResultNodataENG",
    name: "nuclearreportResultNodataENG",
    component: () => import("../appointment/eng/nuclearreportResultNodata"),
    meta: {
      title: "Check for Nucleic Acid Testing Results",
      background: "gray",
    },
  },

  {
    path: "/appointment/nuclearJA",
    name: "nuclearJA",
    component: () => import("../appointment/ja/nuclearIndex"),
    meta: {
      title: "PCR検査状況検索",
      background: "gray",
      keepAlive: true,
    },
  },
  {
    path: "/appointment/nuclearreportResultJA",
    name: "nuclearreportResultJA",
    component: () => import("../appointment/ja/nuclearreportResult"),
    meta: {
      title: "PCR検査の結果検索",
    },
  },
  {
    path: "/appointment/nuclearreportdetail2JA",
    name: "nuclearreportdetail2JA",
    component: () => import("../appointment/ja/nuclearreportdetail2"),
    meta: {
      title: "PCR検査検体採取の記録検索",
      background: "gray",
    },
  },
  {
    path: "/appointment/nuclearreportNodataJA",
    name: "nuclearreportNodataJA",
    component: () => import("../appointment/ja/nuclearreportNodata"),
    meta: {
      title: "PCR検査検体採取の記録検索",
      background: "gray",
    },
  },
  {
    path: "/appointment/nuclearreportResultNodataJA",
    name: "nuclearreportResultNodataJA",
    component: () => import("../appointment/ja/nuclearreportResultNodata"),
    meta: {
      title: "PCR検査の結果検索",
      background: "gray",
    },
  },
  {
    path: "/appointment/nuclearKO",
    name: "nuclearKO",
    component: () => import("../appointment/ko/nuclearIndex"),
    meta: {
      title: "핵산 검사 상황 조회",
      background: "gray",
      keepAlive: true,
    },
  },
  {
    path: "/appointment/nuclearreportResultKO",
    name: "nuclearreportResultKO",
    component: () => import("../appointment/ko/nuclearreportResult"),
    meta: {
      title: "핵산 검사 결과 조회",
    },
  },
  {
    path: "/appointment/nuclearreportdetail2KO",
    name: "nuclearreportdetail2KO",
    component: () => import("../appointment/ko/nuclearreportdetail2"),
    meta: {
      title: "핵산 검사 검체 채취 기록 조회",
      background: "gray",
    },
  },
  {
    path: "/appointment/nuclearreportNodataKO",
    name: "nuclearreportNodataKO",
    component: () => import("../appointment/ko/nuclearreportNodata"),
    meta: {
      title: "핵산 검사 검체 채취 기록 조회",
      background: "gray",
    },
  },
  {
    path: "/appointment/nuclearreportResultNodataKO",
    name: "nuclearreportResultNodataKO",
    component: () => import("../appointment/ko/nuclearreportResultNodata"),
    meta: {
      title: "핵산 검사 결과 조회",
      background: "gray",
    },
  },

  {
    path: "/appointment/order-success",
    name: "appointment-order-success",
    component: () => import("../appointment/orderSuccess"),
    meta: {
      title: "预约成功",
    },
  },
  {
    path: "/appointment/home",
    name: "appointment-home",
    component: () => import("../appointment/home"),
    meta: {
      title: "挂号预约",
      keepAlive: true,
      isBack: false,
    },
  },
  {
    path: "/appointment/confirm-appoint",
    name: "confirm-appoint",
    component: () => import("../appointment/confirm-appoint"),
    meta: {
      title: "确认预约",
      keepAlive: true,
      isBack: false,
    },
  },
  {
    path: "/appointment/appoint-record",
    name: "appoint-record",
    component: () => import("../appointment/appoint-record"),
    meta: {
      title: "预约记录",
    },
  },
  {
    path: "/appointment/appoint-agreement",
    name: "appoint-agreement",
    component: () => import("../appointment/appoint-agreement"),
    meta: {
      title: "挂号协议",
    },
  },
  {
    path: "/appointment/nuclearListNew",
    name: "nuclearListNew",
    component: () => import("../appointment/nuclearListNew"),
    meta: {
      title: "核酸检测",
    },
  },
  {
    path: "/appointment/nuclearListNew1",
    name: "nuclearListNew1",
    component: () => import("../appointment/nuclearListNew"),
    meta: {
      title: "核酸检测",
    },
  },
  {
    path: "/appointment/nuclearListNew2",
    name: "nuclearListNew2",
    component: () => import("../appointment/nuclearListNew"),
    meta: {
      title: "核酸检测",
    },
  },
  {
    path: "/appointment/nuclearListNew3",
    name: "nuclearListNew3",
    component: () => import("../appointment/nuclearListNew"),
    meta: {
      title: "核酸检测",
    },
  },
  {
    path: "/appointment/nuclearListNew4",
    name: "nuclearListNew4",
    component: () => import("../appointment/nuclearListNew"),
    meta: {
      title: "核酸检测",
    },
  },
  {
    path: "/appointment/nuclearListNew5",
    name: "nuclearListNew5",
    component: () => import("../appointment/nuclearListNew2"),
    meta: {
      title: "核酸检测",
    },
  },
  {
    path: "/appointment/nuclearList-sip",
    name: "nuclearList-sip",
    component: () => import("../appointment/nuclearList-sip"),
    meta: {
      title: "园区全员核酸检测采样点",
    },
  },
  {
    path: "/appointment/nuclear-apply",
    name: "appoint-nuclear-apply",
    component: () => import("../appointment/nuclear-apply"),
    meta: {
      title: "核酸检测预约登记",
      keepAlive: false,
    },
  },
  {
    path: "/appointment/nuclear-apply1",
    name: "appoint-nuclear-apply1",
    component: () => import("../appointment/nuclear-apply"),
    meta: {
      title: "核酸检测预约登记",
      keepAlive: false,
    },
  },
  {
    path: "/appointment/nuclear-apply2",
    name: "appoint-nuclear-apply2",
    component: () => import("../appointment/nuclear-end-img"),
    meta: {
      title: "核酸检测预约登记",
      keepAlive: false,
    },
  },
  {
    path: "/appointment/nuclear-apply-success",
    name: "nuclear-apply-success",
    component: () => import("../appointment/nuclear-apply-success"),
    meta: {
      title: "预约登记成功",
    },
  },
  {
    path: "/appointment/nuclear-apply-detail",
    name: "nuclear-apply-detail",
    component: () => import("../appointment/nuclear-apply-detail"),
    meta: {
      title: "预约登记结果",
    },
  },
  {
    path: "/appointment/nuclear-apply-detail1",
    name: "nuclear-apply-detail1",
    component: () => import("../appointment/nuclear-apply-detail"),
    meta: {
      title: "预约登记结果",
    },
  },
  {
    path: "/appointment/nuclear-apply-detail2",
    name: "nuclear-apply-detail2",
    component: () => import("../appointment/nuclear-end-img"),
    meta: {
      title: "预约登记结果",
    },
  },
  // {
  //   path: '/appointment/nuclearApplyH5',
  //   name: 'appoint-nuclear-apply-h5',
  //   component: () => import('../appointment/nuclear-apply-h5'),
  //   meta: {
  //     title: '苏州市核酸检测预约登记'
  //   }
  // },
  {
    path: "/appointment/nuclearApplyH5",
    name: "appoint-nuclear-apply-h5-login",
    component: () => import("../appointment/nuclear-end-img"),
    meta: {
      title: "苏州市核酸检测预约登记",
      keepAlive: false,
    },
  },
  {
    path: "/appointment/nuclearApplyH5Login",
    name: "appoint-nuclear-apply-h5-login",
    component: () => import("../appointment/nuclear-apply-h5-login"),
    meta: {
      title: "苏州市核酸检测预约登记",
      keepAlive: false,
    },
  },
  {
    path: "/appointment/nuclearApplyH5New",
    name: "appoint-nuclear-apply-h5-login-new",
    component: () => import("../appointment/nuclear-end-img"),
    meta: {
      title: "苏州市核酸检测预约登记",
      keepAlive: false,
    },
  },
  {
    path: "/appointment/nuclearApplyH5List",
    name: "appoint-nuclear-apply-h5-list",
    component: () => import("../appointment/nuclear-apply-h5-list"),
    meta: {
      title: "苏州市核酸检测预约登记",
    },
  },
  {
    path: "/appointment/nuclearApplyH5Index",
    name: "appoint-nuclear-apply-h5-v1",
    component: () => import("../appointment/nuclear-apply-h5-v1"),
    meta: {
      title: "苏州市核酸检测预约登记",
    },
  },
  {
    path: "/appointment/nuclear-apply-h5-success",
    name: "nuclear-apply-h5-success",
    component: () => import("../appointment/nuclear-apply-h5-success"),
    meta: {
      title: "预约登记成功",
    },
  },
  {
    path: "/appointment/nuclear-apply-h5-detail",
    name: "nuclear-apply-h5-detail",
    component: () => import("../appointment/nuclear-apply-h5-detail"),
    meta: {
      title: "预约登记结果",
    },
  },
  {
    path: "/appointment/nuclear-apply-h5-detail1",
    name: "nuclear-apply-h5-detail1",
    component: () => import("../appointment/nuclear-apply-h5-detail"),
    meta: {
      title: "预约登记结果",
    },
  },
  {
    path: "/appointment/nuclearListCorp",
    name: "nuclearListCorp",
    component: () => import("../appointment/nuclearListCorp"),
    meta: {
      title: "企业核酸检测预约登记",
    },
  },
  {
    path: "/appointment/nuclear-apply-corp",
    name: "appoint-nuclear-apply-corp",
    component: () => import("../appointment/nuclear-apply-corp"),
    meta: {
      title: "企业核酸检测预约登记",
    },
  },
  {
    path: "/appointment/nuclear-apply-corp-success",
    name: "nuclear-apply-corp-success",
    component: () => import("../appointment/nuclear-apply-corp-success"),
    meta: {
      title: "预约登记成功",
    },
  },
  {
    path: "/appointment/nuclear-apply-corp-detail",
    name: "nuclear-apply-corp-detail",
    component: () => import("../appointment/nuclear-apply-corp-detail"),
    meta: {
      title: "预约登记结果",
    },
  },
  {
    path: "/appointment/nuclear-apply-corp-detail1",
    name: "nuclear-apply-corp-detail1",
    component: () => import("../appointment/nuclear-apply-corp-detail"),
    meta: {
      title: "预约登记结果",
    },
  },
  {
    path: "/appointment/nuclearListShegong",
    name: "nuclearListShegong",
    component: () => import("../appointment/nuclearListShegong"),
    meta: {
      title: "核酸检测预约登记社工版",
    },
  },
  // {
  //   path: '/appointment/nuclearListShegong',
  //   name: 'nuclearListShegong',
  //   component: () => import('../appointment/nuclear-end-img'),
  //   meta: {
  //     title: '核酸检测预约登记社工版'
  //   }
  // },
  {
    path: "/appointment/nuclear-apply-shegong",
    name: "appoint-nuclear-apply-shegong",
    component: () => import("../appointment/nuclear-apply-shegong"),
    meta: {
      title: "核酸检测预约登记社工版",
    },
  },
  {
    path: "/appointment/nuclear-apply-shegong-detail",
    name: "nuclear-apply-shegong-detail",
    component: () => import("../appointment/nuclear-apply-shegong-detail"),
    meta: {
      title: "预约登记结果社工版",
    },
  },
  {
    path: "/appointment/nuclear-apply-shegong-detail1",
    name: "nuclear-apply-shegong-detail1",
    component: () => import("../appointment/nuclear-apply-shegong-detail"),
    meta: {
      title: "预约登记结果社工版",
    },
  },
  {
    path: "/blood-donation/home",
    name: "blood-donation",
    component: () => import("../blood-donation/home"),
    meta: {
      title: "献血服务",
    },
  },
  {
    path: "/blood-donation/common-sense",
    name: "common-sense",
    component: () => import("../blood-donation/common-sense"),
    meta: {
      title: "献血常识",
    },
  },
  {
    path: "/blood-donation/be-careful",
    name: "be-careful",
    component: () => import("../blood-donation/be-careful"),
    meta: {
      title: "注意事项",
    },
  },
  {
    path: "/blood-donation/statute",
    name: "blood-statute",
    component: () => import("../blood-donation/statute"),
    meta: {
      title: "献血法规",
    },
  },
  {
    path: "/blood-donation/place",
    name: "blood-place",
    component: () => import("../blood-donation/place"),
    meta: {
      title: "献血地点",
    },
  },
  {
    path: "/blood-donation/donation-record",
    name: "donation-record",
    component: () => import("../blood-donation/donation-record"),
    meta: {
      title: "献血记录",
    },
  },
  {
    path: "/report-query/home",
    name: "report-home",
    component: () => import("../reportquery/home"),
    meta: {
      title: "检验报告",
      keepAlive: true,
    },
  },
  {
    path: "/report-query/newlist",
    name: "report-home-newlist",
    component: () => import("../reportquery/newlist"),
    meta: {
      title: "检验报告",
      keepAlive: true,
    },
  },
  {
    path: "/report-query/ancillarydetail",
    name: "ancillarydetail",
    component: () => import("../reportquery/ancillarydetail"),
    meta: {
      title: "检验详情",
    },
  },
  {
    path: "/report-query/labdetail",
    name: "labdetail",
    component: () => import("../reportquery/labdetail"),
    meta: {
      title: "检验详情",
    },
  },
  {
    path: "/report-query/newlist",
    name: "report-home-newlist",
    component: () => import("../reportquery/newlist"),
    meta: {
      title: "检验报告列表",
      keepAlive: true,
    },
  },
  {
    path: "/report-query/other",
    name: "report-other",
    component: () => import("../reportquery/other-query"),
    meta: {
      title: "其它查询",
      keepAlive: true,
    },
  },
  {
    path: "/report-query/query-detail",
    name: "query-detail",
    component: () => import("../reportquery/query-detail"),
    meta: {
      title: "检验详情",
    },
  },
  {
    path: "/report-query/study-detail",
    name: "study-detail",
    component: () => import("../reportquery/study-detail"),
    meta: {
      title: "检验详情",
    },
  },
  {
    path: "/family-circle/home",
    name: "family-home",
    component: () => import("../familycircle/home"),
    meta: {
      title: "生活圈",
      background: "gray",
    },
  },
  {
    path: "/family-circle/add",
    name: "family-add",
    component: () => import("../familycircle/add-family"),
    meta: {
      title: "添加成员",
    },
  },
  {
    path: "/family-circle/addNew",
    name: "family-addNew",
    component: () => import("../familycircle/add-familyNew"),
    meta: {
      title: " ",
    },
  },
  {
    path: "/family-circle/addforeigner",
    name: "family-addforeigner",
    component: () => import("../familycircle/add-foreginer"),
    meta: {
      title: "添加成员",
    },
  },
  {
    path: "/medical-resources/home",
    name: "medical-home",
    component: () => import("../medical-resources/home"),
    meta: {
      title: "医疗资源",
      keepAlive: true,
    },
  },
  {
    path: "/medical-resources/community-institutions",
    name: "community-institutions",
    component: () => import("../medical-resources/community-institutions"),
    meta: {
      title: "社区机构详情",
    },
  },
  {
    path: "/medical-resources/hospital-institution",
    name: "hospital-institution",
    component: () => import("../medical-resources/hospital-institution"),
    meta: {
      title: "医院详情",
    },
  },
  {
    path: "/physical-examination/home",
    name: "physical-examination",
    component: () => import("../physical-examination/home"),
    meta: {
      title: "体检报告",
      keepAlive: true,
    },
  },
  {
    path: "/physical-examination/newlist",
    name: "physical-examination-newlist",
    component: () => import("../physical-examination/newlist"),
    meta: {
      title: "体检报告",
      keepAlive: true,
    },
  },
  {
    path: "/physical-examination/query-detail",
    name: "physical-query-detail",
    component: () => import("../physical-examination/query-detail"),
    meta: {
      title: "体检报告",
    },
  },
  {
    path: "/physical-examination/new-detail",
    name: "physical-new-detail",
    component: () => import("../physical-examination/new-detail"),
    meta: {
      title: "体检报告",
    },
  },
  {
    path: "/physical-examination/nuclear",
    name: "physical-nuclear",
    component: () => import("../physical-examination/nuclear"),
    meta: {
      title: "核酸报告",
    },
  },
  {
    path: "/authorization-management/index",
    name: "authorization-management-index",
    component: () => import("../authorization-management/index"),
    meta: {
      title: "授权管理",
    },
  },
  {
    path: "/authorization-management/detail",
    name: "authorization-management-detail",
    component: () => import("../authorization-management/detail"),
    meta: {
      title: "授权详情",
      background: "gray",
    },
  },
  {
    path: "/authorization-management/test",
    name: "authorization-management-test",
    component: () => import("../authorization-management/test"),
    meta: {
      title: "测试",
    },
  },
  {
    path: "/personal-social/query",
    name: "personal-social-query",
    component: () => import("../personal-social/index"),
    meta: {
      title: "个人社保信息",
    },
  },
  {
    path: "/personal-social/income",
    name: "personal-social-income",
    component: () => import("../personal-social/income"),
    meta: {
      title: "待遇收入证明",
    },
  },
  {
    path: "/personal-social/medical-list",
    name: "personal-social-medical-list",
    component: () => import("../personal-social/medical-list"),
    meta: {
      title: "居民医保缴费记录",
      keepAlive: true,
    },
  },
  {
    path: "/personal-social/medical-detail",
    name: "personal-social-medical-detail",
    component: () => import("../personal-social/medical-detail"),
    meta: {
      title: "居民医保缴费记录",
    },
  },
  {
    path: "/payment-record/home",
    name: "payment-record-home",
    component: () => import("../payment-record/home"),
    meta: {
      title: "社保缴费",
      keepAlive: true,
    },
  },
  {
    path: "/payment-record/detail",
    name: "payment-record-detail",
    component: () => import("../payment-record/detail"),
    meta: {
      title: "缴费明细",
      keepAlive: false,
      isBack: false,
    },
  },
  {
    path: "/payment-record/month-detail",
    name: "payment-record-month-detail",
    component: () => import("../payment-record/month-detail"),
    meta: {
      title: "月度明细",
    },
  },
];
const discard = [
  {
    path: "/old-gas/pay",
    name: "old-gas-pay",
    component: () => import("../gas/pay"),
    meta: {
      title: "燃气缴费",
    },
  },
  {
    path: "/old-gas/add-user",
    name: "old-gas-add-user",
    component: () => import("../gas/add-user"),
    meta: {
      title: "新增缴费账户",
    },
  },
  {
    path: "/old-gas/get-account",
    name: "old-gas-get-account",
    component: () => import("../gas/get-account"),
    meta: {
      title: "如何获取燃气户号",
    },
  },
  {
    path: "/old-gas/recharge",
    name: "old-gas-recharge",
    component: () => import("../gas/recharge"),
    meta: {
      title: "燃气充值",
      keepAlive: true,
    },
  },
  {
    path: "/old-gas/user-manage",
    name: "old-gas-user-manage",
    component: () => import("../gas/user-manage"),
    meta: {
      title: "户号管理",
    },
  },
  {
    path: "/old-gas/pay-record",
    name: "old-gas-pay-record",
    component: () => import("../gas/pay-record"),
    meta: {
      title: "缴费记录",
    },
  },
  {
    path: "/old-gas/no-net",
    name: "old-gas-no-net",
    component: () => import("../gas/no-net"),
    meta: {
      title: "断网空页面",
    },
  },
  {
    path: "/convenience/list",
    name: "convenience-list",
    component: () =>
      import(/* webpackChunkName: "about" */ "../convenience/index"),
    meta: {
      title: "我的述求",
    },
  },
  {
    path: "/convenience/detail",
    name: "convenience-detail",
    component: () =>
      import(/* webpackChunkName: "about" */ "../convenience/detail"),
    meta: {
      title: "我的述求",
    },
  },
  {
    path: "/convenience/add",
    name: "convenience-add",
    component: () =>
      import(/* webpackChunkName: "about" */ "../convenience/add"),
    meta: {
      title: "12345",
    },
  },
];
const rs = [
  {
    path: "/Renshe/nodata",
    name: "rsnodata",
    component: () => import("../Renshe/nodata"),
  },
  {
    path: "/Renshe/JiuyeHardCha",
    name: "jiuyehardcha",
    component: () => import("../Renshe/JiuyeHardCha/Index"),
    meta: {
      title: "申报就业",
    },
  },
  {
    path: "/Renshe/JiuyeHardCha/confirm",
    name: "jiuyehardchaconfirm",
    component: () => import("../Renshe/JiuyeHardCha/confirm"),
    meta: {
      title: "申报就业",
    },
  },
  {
    path: "/Renshe/JiuyeHardCha/result",
    name: "jiuyehardcharesult",
    component: () => import("../Renshe/JiuyeHardCha/Result"),
    meta: {
      title: "申报就业",
    },
  },
  {
    path: "/Renshe/train",
    name: "train",
    component: () => import("../Renshe/train/index"),
    meta: {
      title: "创业培训报名",
    },
  },
  {
    path: "/Renshe/train/confirm",
    name: "trainconfirm",
    component: () => import("../Renshe/train/confirm"),
    meta: {
      title: "创业培训报名",
    },
  },
  {
    path: "/Renshe/train/result",
    name: "trainresult",
    component: () => import("../Renshe/train/result"),
    meta: {
      title: "创业培训报名",
    },
  },
  {
    path: "/Renshe/social",
    name: "social",
    component: () => import("../Renshe/social/Index"),
    meta: {
      title: "社保卡状态查询",
    },
  },
  {
    path: "/Renshe/social/result",
    name: "socialresult",
    component: () => import("../Renshe/social/Result"),
    meta: {
      title: "社保卡状态查询",
    },
  },
  {
    path: "/Renshe/Insurance",
    name: "insurance",
    component: () => import("../Renshe/Insurance/index"),
    meta: {
      title: "个人参保证明",
    },
  },
  {
    path: "/Renshe/Insurance/result",
    name: "insuranceresult",
    component: () => import("../Renshe/Insurance/insResult"),
    meta: {
      title: "个人参保证明",
    },
  },
  {
    path: "/Renshe/work",
    name: "renshework",
    component: () => import("../Renshe/work/index"),
    meta: {
      title: "《就业创业证》申请",
    },
  },
  {
    path: "/Renshe/work/result",
    name: "rensheworkresult",
    component: () => import("../Renshe/work/result"),
    meta: {
      title: "《就业创业证》申请",
    },
  },
  {
    path: "/Renshe/work/confirm",
    name: "rensheworkconfirm",
    component: () => import("../Renshe/work/confirm"),
    meta: {
      title: "《就业创业证》申请",
    },
  },
  {
    path: "/Renshe/diff",
    name: "renshediff",
    component: () => import("../Renshe/diff/index"),
    meta: {
      title: "就业困难人员申报",
    },
  },
  {
    path: "/Renshe/diff/result",
    name: "renshediffresult",
    component: () => import("../Renshe/diff/result"),
    meta: {
      title: "就业困难人员申报",
    },
  },
  {
    path: "/Renshe/diff/confirm",
    name: "renshediffconfirm",
    component: () => import("../Renshe/diff/confirm"),
    meta: {
      title: "就业困难人员申报",
    },
  },
  {
    path: "/Renshe/workselect",
    name: "workselect",
    component: () => import("../Renshe/work-select/Index"),
    meta: {
      title: "《就业创业证》查询",
    },
  },
  {
    path: "/Renshe/workselect/result",
    name: "workselectresult",
    component: () => import("../Renshe/work-select/Result"),
    meta: {
      title: "《就业创业证》查询",
    },
  },
  {
    path: "/Renshe/diffselect",
    name: "diffselect",
    component: () => import("../Renshe/diff-select/Index"),
    meta: {
      title: "就业困难人员查询",
    },
  },
  {
    path: "/Renshe/diffselect/result",
    name: "diffselectresult",
    component: () => import("../Renshe/diff-select/Result"),
    meta: {
      title: "就业困难人员查询",
    },
  },
  {
    path: "/Renshe/employment",
    name: "employment",
    component: () => import("../Renshe/employment/index"),
    meta: {
      title: "失业保险金申报",
    },
  },
  {
    path: "/Renshe/employment/confirm",
    name: "employmentconfirm",
    component: () => import("../Renshe/employment/confirm"),
    meta: {
      title: "失业保险金申报",
    },
  },
  {
    path: "/Renshe/employment/result",
    name: "employmentresult",
    component: () => import("../Renshe/employment/result"),
    meta: {
      title: "失业保险金申报",
    },
  },
  {
    path: "/Renshe/unemployment",
    name: "unemployment",
    component: () => import("../Renshe/unemployment/Index"),
    meta: {
      title: "失业登记申报",
    },
  },
  {
    path: "/Renshe/unemployment/confirm",
    name: "unemploymentconfirm",
    component: () => import("../Renshe/unemployment/confirm"),
    meta: {
      title: "失业登记申报",
    },
  },
  {
    path: "/Renshe/unemployment/result",
    name: "unemploymentresult",
    component: () => import("../Renshe/unemployment/Result"),
    meta: {
      title: "失业登记查询",
    },
  },
  {
    path: "/pillSearch/index",
    name: "pillSearchindex",
    component: () => import("../pillSearch/index"),
    meta: {
      title: "药品查询",
    },
  },
  {
    path: "/pillSearch/details",
    name: "pillSearchdetail",
    component: () => import("../pillSearch/details"),
    meta: {
      title: "药品详情",
    },
  },
  {
    path: "/pillSearch/list",
    name: "pillSearchlist",
    component: () => import("../pillSearch/list"),
    meta: {
      title: "药品查询",
    },
  },
  {
    path: "/treatSearch/index",
    name: "treatSearchindex",
    component: () => import("../treatSearch/index"),
    meta: {
      title: "诊疗项目查询",
    },
  },
  {
    path: "/treatSearch/details",
    name: "treatSearchdetail",
    component: () => import("../treatSearch/details"),
    meta: {
      title: "诊疗项目查询",
    },
  },
  {
    path: "/treatSearch/list",
    name: "treatSearchlist",
    component: () => import("../treatSearch/list"),
    meta: {
      title: "诊疗项目查询",
    },
  },
  {
    path: "/MedicalMaterials/index",
    name: "MedicalSearchindex",
    component: () => import("../MedicalMaterials/index"),
    meta: {
      title: "医疗材料库",
    },
  },
  {
    path: "/MedicalMaterials/detail",
    name: "MedicalSearchdetail",
    component: () => import("../MedicalMaterials/detail"),
    meta: {
      title: "医疗材料库",
    },
  },
  {
    path: "/MedicalMaterials/list",
    name: "MedicalSearchlist",
    component: () => import("../MedicalMaterials/list"),
    meta: {
      title: "医疗材料库",
    },
  },
];

const edu = [
  {
    path: "/education/xueli",
    name: "Education",
    component: () => import("../Education/Index"),
    meta: {
      title: "高校学历查询",
    },
  },
  {
    path: "/education/error",
    name: "educationError",
    component: () => import("../Education/error"),
    meta: {
      title: " ",
    },
  },
  {
    path: "/education/xueli/querynumber",
    name: "QueryNumber",
    component: () => import("../Education/Number/QueryNumber"),
    meta: {
      title: "高校学历查询",
      background: "gray",
    },
  },
  {
    path: "/education/xueli/queryidcard",
    name: "QueryIdcard",
    component: () => import("../Education/Idcard/QueryIdcard"),
    meta: {
      title: "高校学历查询",
      background: "gray",
    },
  },
  {
    path: "/education/xueli/queryxueji",
    name: "QueryXueji",
    component: () => import("../Education/Xueji/QueryXueji"),
    meta: {
      title: "高校学籍查询",
      background: "gray",
    },
  },
  {
    path: "/education/xueli/querynumber/result",
    name: "QueryNumberResult",
    component: () => import("../Education/Number/QueryNumberResult"),
    meta: {
      title: "高校学历查询",
      background: "gray",
    },
  },
  {
    path: "/education/xueli/querynumber/detail",
    name: "QueryNumberDetail",
    component: () => import("../Education/Number/QueryNumberDetail"),
    meta: {
      title: "高校学历查询",
    },
  },
  {
    path: "/education/xueli/queryidcard/result",
    name: "QueryIdcardResult",
    component: () => import("../Education/Idcard/QueryIdcardResult"),
    meta: {
      title: "高校学历查询",
      background: "gray",
    },
  },
  {
    path: "/education/xueli/queryidcard/detail",
    name: "QueryIdcardDetail",
    component: () => import("../Education/Idcard/QueryIdcardDetail"),
    meta: {
      title: "高校学历查询",
    },
  },
  {
    path: "/education/xueli/queryxueji/result",
    name: "QueryXuejiResult",
    component: () => import("../Education/Xueji/QueryXuejiResult"),
    meta: {
      title: "高校学籍查询（在校生）",
      background: "gray",
    },
  },
  {
    path: "/education/xueli/queryxueji/detail",
    name: "QueryXuejiDetail",
    component: () => import("../Education/Xueji/QueryXuejiDetail"),
    meta: {
      title: "高校学籍查询",
    },
  },
  {
    path: "/education/zhongkao/query",
    name: "QueryZhongkao",
    component: () => import("../Education/Zhongkao/Index"),
    meta: {
      title: "中考查询",
      background: "gray",
    },
  },
  {
    path: "/education/zhongkao/result",
    name: "QueryZhongkaoResult",
    component: () => import("../Education/Zhongkao/Result"),
    meta: {
      title: "中考查询详情",
    },
  },
  {
    path: "/flowerpoint/index",
    name: "flowerpoint",
    component: () => import("../flowerpoint/index"),
    meta: {
      title: "桂花分查询",
    },
  },
];

const gongan = [
  {
    path: "/gongan/traffic/index",
    name: "TrafficIndex",
    component: () => import("../Gongan/Traffic/index"),
    meta: {
      title: "交管服务",
    },
  },
  {
    path: "/gongan/jifen",
    name: "ShiminJifen",
    component: () => import("../Gongan/Jifen/Index"),
    meta: {
      title: "新市民积分查询",
      background: "gray",
    },
  },
  {
    path: "/gongan/multiname",
    name: "Multiname",
    component: () => import("../Gongan/Multiname/Index"),
    meta: {
      title: "重名查询",
      background: "gray",
    },
  },
  {
    path: "/gongan/gangaotai/juzhuzhen/guide",
    name: "GATJuzhuzhenGuide",
    component: () => import("../Gongan/GangAoTai/Juzhuzheng/Guide"),
    meta: {
      title: "港澳台居民居住证办理指南",
    },
  },
  {
    path: "/weather",
    name: "weather",
    component: () => import("../weather/index"),
    meta: {
      title: "天气",
    },
  },
  {
    path: "/subway",
    name: "subway",
    component: () => import("../subway/index"),
    meta: {
      title: "首末班时间",
    },
  },
  {
    path: "/subwayEN",
    name: "subwayEN",
    component: () => import("../subway/index-en"),
    meta: {
      title: "Tram timetable",
    },
  },
  {
    path: "/subwayJA",
    name: "subwayJA",
    component: () => import("../subway/index-ja"),
    meta: {
      title: "電車時刻表",
    },
  },
  {
    path: "/subwayKO",
    name: "subwayKO",
    component: () => import("../subway/index-ko"),
    meta: {
      title: "전차시간표",
    },
  },
  {
    path: "/allowance",
    name: "allowance",
    component: () => import("../allowance/index"),
    meta: {
      title: "高龄老人津贴标准",
    },
  },
  {
    path: "/idcardquery",
    name: "IdcardQuery",
    component: () => import("../Gongan/IdcardQuery/Index"),
    meta: {
      title: "居民身份证",
      keepAlive: true,
    },
  },
  {
    path: "/marryQuery",
    name: "marryQuery",
    component: () => import("../Gongan/Marry/Index"),
    meta: {
      title: "婚姻登记证",
      keepAlive: true,
    },
  },
  {
    path: "/medicare",
    name: "medicare",
    component: () => import("../Gongan/Medicare/index"),
    meta: {
      title: "医保电子凭证",
      keepAlive: true,
    },
  },
  {
    path: "/medicare/apply",
    name: "medicareApply",
    component: () => import("../Gongan/Medicare/apply"),
    meta: {
      title: "医保电子凭证",
      keepAlive: true,
      background: "gray",
    },
  },
  {
    path: "/personlicence",
    name: "PersonLicence",
    component: () => import("../Gongan/Licence"),
    meta: {
      title: "",
    },
  },
  {
    path: "/drivelicensequery",
    name: "DriveLicenseQuery",
    component: () => import("../Gongan/DriveLicenseQuery/Index"),
    meta: {
      title: "机动车驾驶证",
      keepAlive: true,
    },
  },
  {
    path: "/drivepermitquery",
    name: "DrivePermitQuery",
    component: () => import("../Gongan/DrivePermit/Index"),
    meta: {
      title: "行驶证查询",
    },
  },
  {
    path: "/drivepermitadd",
    name: "DrivePermitAdd",
    component: () => import("../Gongan/DrivePermit/Add"),
    meta: {
      title: "行驶证添加",
    },
  },
  {
    path: "/drivepermitshow",
    name: "DrivePermitShow",
    component: () => import("../Gongan/DrivePermit/Show"),
    meta: {
      title: "机动车行驶证",
      keepAlive: true,
    },
  },
  {
    path: "/hukouquery",
    name: "HukouQuery",
    component: () => import("../Gongan/HukouQuery/Index"),
    meta: {
      title: "户口簿",
      keepAlive: true,
    },
  },
  {
    path: "/juzhuzheng",
    name: "JuzhuZheng",
    component: () => import("../Gongan/JuzhuZheng/Index"),
    meta: {
      title: "江苏省居住证",
      keepAlive: true,
    },
  },
  {
    path: "/ecard",
    name: "ecard",
    component: () => import("../Gongan/ECard/Index"),
    meta: {
      title: "教育E卡通",
      keepAlive: true,
    },
  },
  {
    path: "/ecard/canjiren",
    name: "ecardcanjiren",
    component: () => import("../Gongan/ECard/canjiren"),
    meta: {
      title: "残疾人证",
      keepAlive: true,
    },
  },
  {
    path: "/ecard/laomo",
    name: "ecardlaomo",
    component: () => import("../Gongan/ECard/laomo"),
    meta: {
      title: "劳模证",
      keepAlive: true,
    },
  },
  {
    path: "/tax2",
    name: "tax2",
    component: () => import("../Gongan/tax/index"),
    meta: {
      title: "个人所得税",
    },
  },
  {
    path: "/occupation",
    name: "occupation",
    component: () => import("../Gongan/Occupation/Index"),
    meta: {
      title: "技能人员类职业资格证书",
      keepAlive: true,
    },
  },
  {
    path: "/socialcard",
    name: "socialcard",
    component: () => import("../Gongan/Social/Index"),
    meta: {
      title: "社会保障卡",
      keepAlive: true,
    },
  },
  {
    path: "/roadcard",
    name: "roadcard",
    component: () => import("../Gongan/Road/Index"),
    meta: {
      title: "道路运输从业资格证",
      keepAlive: true,
    },
  },
  {
    path: "/insurancecard",
    name: "insurancecard",
    component: () => import("../Gongan/Insurance/Index"),
    meta: {
      title: "保险销售从业人员执业证",
      keepAlive: true,
    },
  },
  {
    path: "/aopa",
    name: "aopa",
    component: () => import("../Gongan/UAV/aopa"),
    meta: {
      title: "无人机执照（AOPA）",
      keepAlive: true,
    },
  },
  {
    path: "/asfc",
    name: "asfc",
    component: () => import("../Gongan/UAV/asfc"),
    meta: {
      title: "无人机执照（ASFC）",
      keepAlive: true,
    },
  },
  {
    path: "/birth",
    name: "birth",
    component: () => import("../Gongan/birth/Index"),
    meta: {
      title: "出生医学证明",
      keepAlive: true,
    },
  },
];

const gongyi = [
  {
    path: "/gongyi/childwelfare/address",
    name: "ChildWelfareAddress",
    component: () => import("../Gongyi/ChildWelfare/Address"),
    meta: {
      title: "全市儿童福利机构或部门信息",
    },
  },
];

const other = [
  {
    path: "/activity/strawberry",
    name: "strawberry",
    component: () => import("../activity/strawberry/Index"),
    meta: {
      title: "牛年新春 “苏周到”给你送福利",
    },
  },
  {
    path: "/activity/strawberry/min",
    name: "strawberryMin",
    component: () => import("../activity/strawberry/Min"),
    meta: {
      title: "牛年新春 “苏周到”给你送福利",
    },
  },
  {
    path: "/activity/zhufu/index",
    name: "zhufu",
    component: () => import("../activity/zhufu/index"),
    meta: {
      title: "牛年新春",
    },
  },
  {
    path: "/activity/birdday/index",
    name: "birdday",
    component: () => import("../activity/birdday/Index"),
    meta: {
      title: "",
    },
  },
  {
    path: "/newyear",
    name: "newyear",
    component: () => import("../newyear/index"),
    meta: {
      title: "“苏周到”新年送福",
    },
  },
  {
    path: "/lawSz/index",
    name: "lawSz",
    component: () => import("../lawSz/index"),
    meta: {
      title: "法润苏州",
    },
  },
  {
    path: "/lawSz/list",
    name: "lawSzlist",
    component: () => import("../lawSz/list"),
    meta: {
      title: "法润苏州",
    },
  },
  {
    path: "/extend",
    name: "extend",
    component: () => import("../newyear/extend"),
    meta: {
      title: "苏周到云拜年",
    },
  },
  {
    path: "/cny",
    name: "cny",
    component: () => import("../newyear/extend3"),
    meta: {
      title: "苏周到云拜年",
    },
  },
  {
    path: "/meetingRule",
    name: "meetingRule",
    component: () => import("../newyear/rule"),
    meta: {
      title: "活动规则",
    },
  },
  {
    path: "/ctid",
    name: "ctid",
    component: () => import("../ctid/index"),
    meta: {
      title: "CTID官方APP使用说明",
    },
  },
  {
    path: "/traffic/main",
    name: "trafficmain",
    component: () => import("../traffic/main"),
    meta: {
      title: "交通违法处理窗口",
    },
  },
  {
    path: "/pass/main",
    name: "passmain",
    component: () => import("../pass/main"),
    meta: {
      title: "出入境服务",
    },
  },
  {
    path: "/data/index",
    name: "dataError",
    component: () => import("../data/index"),
    meta: {
      title: "接口预警",
    },
  },
  {
    path: "/askservice",
    name: "askservice",
    component: () => import("../askservice/index"),
    meta: {
      title: "我要咨询",
    },
  },
  {
    path: "/askservice/index",
    name: "askserviceindex",
    component: () => import("../askservice/main"),
    meta: {
      title: "客户服务",
    },
  },
  {
    path: "/askservice/detail",
    name: "askservicedetail",
    component: () => import("../askservice/detail"),
    meta: {
      title: "问题解答",
    },
  },
  {
    path: "/marry",
    name: "marry",
    component: () => import("../marry/index"),
    meta: {
      title: "婚姻登记机关查询",
    },
  },
  {
    path: "/child",
    name: "child",
    component: () => import("../marry/child"),
    meta: {
      title: "福利机构查询",
    },
  },
  {
    path: "/countdown",
    name: "countdown",
    component: () => import("../countdown/index2"),
    meta: {
      title: "云拜年",
    },
  },
  {
    path: "*",
    redirect: "/404",
  },
  {
    path: "/",
    name: "HomePage",
    component: () => import("../Home/Index"),
    meta: {
      title: "苏周到",
    },
  },
  {
    path: "/intro",
    name: "intro",
    component: () => import("../Home/intro"),
    meta: {
      title: "关于我们",
    },
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../Home/about"),
    meta: {
      title: "关于我们",
    },
  },
  {
    path: "/download",
    name: "Download",
    component: () => import("../Download/Index"),
    meta: {
      title: "下载苏周到",
    },
  },
  {
    path: "/downloadtoapp",
    name: "DownloadToApp",
    component: () => import("../Download/IndexToApp"),
    meta: {
      title: "下载苏周到",
    },
  },
  {
    path: "/share",
    name: "share",
    component: () => import("../share/indexNew"),
    meta: {
      title: "推荐给好友",
    },
  },
  {
    path: "/share/invite",
    name: "invite",
    component: () => import("../share/invite"),
    meta: {
      title: "推荐给好友",
    },
  },
  {
    path: "/share/amount",
    name: "amount",
    component: () => import("../share/amount"),
    meta: {
      title: "苏周到分码注册统计",
    },
  },
  {
    path: "/share/scanAmount",
    name: "scanAmount",
    component: () => import("../share/scanAmount"),
    meta: {
      title: "下载量",
    },
  },
  {
    path: "/rec",
    name: "rec",
    component: () => import("../rec/index"),
    // component: () => import('../rec/index-back'),
    meta: {
      title: "推荐给好友",
    },
  },
  {
    path: "/rec/main",
    name: "main",
    component: () => import("../rec/mainNew3"),
    meta: {
      title: "推荐给好友",
    },
  },
  {
    path: "/redirect",
    name: "redirect",
    component: () => import("../redirect/index"),
    meta: {
      title: "跳转中...",
    },
  },
  {
    path: "/journey",
    name: "journey",
    component: () => import("../redirect/journey"),
    meta: {
      title: "跳转中...",
    },
  },
  {
    path: "/healthcare",
    name: "healthcare",
    component: () => import("../redirect/healthcare"),
    meta: {
      title: "跳转中...",
    },
  },
  {
    path: "/traffic/index",
    name: "traffic",
    component: () => import("../traffic/index"),
    meta: {
      title: "跳转中...",
    },
  },
  {
    path: "/toCharge",
    name: "toCharge",
    component: () => import("../toCharge/index"),
    meta: {
      title: "跳转中...",
    },
  },
  {
    path: "/gardens",
    name: "gardens",
    component: () => import("../gardens/index"),
    meta: {
      title: "跳转中...",
    },
  },
  {
    path: "/water",
    name: "water",
    component: () => import("../water/index"),
    meta: {
      title: "跳转中...",
    },
  },
  {
    path: "/sukangma",
    name: "sukangma",
    component: () => import("../sukangma/healthycode3"),
    meta: {
      title: "苏康码",
    },
  },
  {
    path: "/healthycode",
    name: "healthycode",
    component: () => import("../sukangma/healthycode3"),
    meta: {
      title: "苏康码",
      keepAlive: true,
    },
  },
  {
    path: "/gettraffic",
    name: "gettraffic",
    component: () => import("../gettraffic/index"),
    meta: {
      title: "跳转中...",
    },
  },
  {
    path: "/gettour",
    name: "gettour",
    component: () => import("../gettour/index"),
    meta: {
      title: "跳转中...",
    },
  },
  {
    path: "/gettour/childindex",
    name: "gettourchildindex",
    component: () => import("../gettour/childindex"),
    meta: {
      title: "跳转中...",
    },
  },
  {
    path: "/getpr",
    name: "getpr",
    component: () => import("../getpr/index"),
    meta: {
      title: "跳转中...",
    },
  },
  {
    path: "/vr/scenes",
    name: "ScenesVR",
    component: () => import("../VR/Scenes"),
    meta: {
      title: "景区VR",
      background: "gray",
    },
  },
  {
    path: "/vr/scenes/eng",
    name: "ScenesVReng",
    component: () => import("../VR/ScenesENG"),
    meta: {
      title: "scenic spot VR",
      background: "gray",
    },
  },
  {
    path: "/vr/scenes/ja",
    name: "ScenesVRja",
    component: () => import("../VR/ScenesJA"),
    meta: {
      title: "観光スポットVR",
      background: "gray",
    },
  },
  {
    path: "/vr/scenes/ko",
    name: "ScenesVRko",
    component: () => import("../VR/ScenesKO"),
    meta: {
      title: "관광지 VR",
      background: "gray",
    },
  },
  {
    path: "/handle",
    name: "Handle",
    component: () => import("../Handle/Index"),
    meta: {
      title: "办事进度",
      background: "gray",
    },
  },
  {
    path: "/gat",
    name: "gat",
    component: () => import("../authorization/GAT"),
    meta: {
      title: " ",
    },
  },
  {
    path: "/gatnew",
    name: "gatnew",
    component: () => import("../authorization/GATNew"),
    meta: {
      title: " ",
    },
  },
  {
    path: "/foreign",
    name: "foreign",
    component: () => import("../authorization/Foreign"),
    meta: {
      title: " ",
    },
  },
  {
    path: "/authorization/index",
    name: "authorization",
    component: () => import("../authorization/index3"),
    meta: {
      title: " ",
      keepAlive: true,
    },
  },
  {
    path: "/authorization/auth-demo",
    name: "auth-demo",
    component: () => import("../authorization/auth-demo"),
  },
  {
    path: "/authorization/openpage",
    name: "openpage",
    component: () => import("../authorization/openpage"),
    meta: {
      title: " ",
      keepAlive: true,
    },
  },
  ,
  {
    path: "/authorization/opencertificate",
    name: "opencertificate",
    component: () => import("../authorization/opencertificate"),
    meta: {
      title: " ",
      keepAlive: true,
    },
  },
  {
    path: "/authorization/auth",
    name: "oauth",
    component: () => import("../authorization/auth"),
    meta: {
      title: "用户授权",
      keepAlive: true,
    },
  },
  {
    path: "/authorization/auth2",
    name: "oauth",
    component: () => import("../authorization/auth2"),
    meta: {
      title: "用户授权",
      keepAlive: true,
    },
  },
  {
    path: "/authorization/quiteOauth",
    name: "quiteOauth",
    component: () => import("../authorization/quiteOauth"),
    meta: {
      title: " ",
      keepAlive: true,
    },
  },
  {
    path: "/authorization/foreignersubmit",
    name: "foreginersubmit",
    component: () => import("../authorization/foreignersubmit2"),
    meta: {
      title: "实名认证",
    },
  },
  {
    path: "/authorization/foreignerEdit",
    name: "foreignerEdit",
    component: () => import("../authorization/foreignerEdit"),
    meta: {
      title: "成员详情",
    },
  },
  {
    path: "/authorization/foreignerReEdit",
    name: "foreignerReEdit",
    component: () => import("../authorization/foreignerReEdit"),
    meta: {
      title: "实名认证",
    },
  },
  {
    path: "/authorization/foreignerAdd",
    name: "foreignerAdd",
    component: () => import("../authorization/foreignerAdd"),
    meta: {
      title: "添加成员",
    },
  },
  {
    path: "/authorization/foreignerdetail",
    name: "foreginerdetail",
    component: () => import("../authorization/foreignerdetail"),
    meta: {
      title: "认证详情",
    },
  },
  {
    path: "/authorization/foreignerresult",
    name: "foreignerresult",
    component: () => import("../authorization/foreignerResult"),
    meta: {
      title: "审核详情",
    },
  },
  {
    path: "/authorization/police",
    name: "authorizationpolice",
    component: () => import("../authorization/police"),
    meta: {
      title: "公安服务授权",
    },
  },
  {
    path: "/authorization/renzheng",
    name: "authorizationrenzheng",
    component: () => import("../authorization/renzheng"),
    meta: {
      title: "实名认证",
    },
  },
  {
    path: "/authorization/addToDesk",
    name: "addToDesk",
    component: () => import("../authorization/addToDesk"),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/authorization/jumpweixin",
    name: "jumpweixin",
    component: () => import("../authorization/jumpweixin"),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/authorization/jumpwxapp",
    name: "jumpwxapp",
    component: () => import("../authorization/jumpwxapp"),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/wenjuan/home",
    name: "WenjuanHome",
    component: () => import("../Wenjuan/Home"),
    meta: {
      title: "问卷调查",
    },
  },
  {
    path: "/wenjuan/beta",
    name: "WenjuanBeta",
    component: () => import("../Wenjuan/Index"),
    meta: {
      title: "问卷调查",
      background: "gray",
    },
  },
  {
    path: "/wenjuan/result",
    name: "WenjuanResult",
    component: () => import("../Wenjuan/Result"),
    meta: {
      title: "问卷调查",
    },
  },
  {
    path: "/offCode/index",
    name: "offCode",
    component: () => import("../offCode/index"),
    meta: {
      title: "扫码核销",
    },
  },
  {
    path: "/offCode/result",
    name: "offcoderesult",
    component: () => import("../offCode/result"),
    meta: {
      title: "兑换结果",
    },
  },
];

const entr = [
  {
    path: "/entrance",
    name: "Entrance",
    component: () => import("../temp/temp-page"),
    meta: {
      title: "入口",
      background: "gray",
    },
  },
];
const canlian = [
  {
    path: "/canlian/workregister",
    name: "workregister",
    component: () => import("../canlian/workregister"),
    meta: {
      title: "残疾人求职登记",
    },
  },
  {
    path: "/canlian/search",
    name: "canliansearch",
    component: () => import("../canlian/search"),
    meta: {
      title: "残疾证查询",
    },
  },
  {
    path: "/canlian/applysupport",
    name: "applysupport",
    component: () => import("../canlian/applysupport"),
    meta: {
      title: "辅具适配申请登记",
    },
  },
];
const rubbish = [
  {
    path: "/rubcycle/main",
    name: "rubcyclemain",
    component: () => import("../rubcycle/main"),
    meta: {
      title: "垃圾分类",
    },
  },
  {
    path: "/rubcycle/index",
    name: "rubcycle",
    component: () => import("../rubcycle/index"),
    meta: {
      title: "垃圾分类",
    },
  },
  {
    path: "/rubcycle/detail",
    name: "rubcycledetail",
    component: () => import("../rubcycle/detail"),
    meta: {
      title: "垃圾详情",
    },
  },

  {
    path: "/rubcycleEN/main",
    name: "rubcycleENmain",
    component: () => import("../rubcycle/en/main"),
    meta: {
      title: "Garbage sorting",
    },
  },
  {
    path: "/rubcycleEN/index",
    name: "rubcycleEN",
    component: () => import("../rubcycle/en/index"),
    meta: {
      title: "Garbage sorting",
    },
  },
  {
    path: "/rubcycleEN/detail",
    name: "rubcycleENdetail",
    component: () => import("../rubcycle/en/detail"),
    meta: {
      title: "Garbage sorting",
    },
  },

  {
    path: "/rubcycleJA/main",
    name: "rubcycleJAmain",
    component: () => import("../rubcycle/ja/main"),
    meta: {
      title: "ごみの分別",
    },
  },
  {
    path: "/rubcycleJA/index",
    name: "rubcycleJA",
    component: () => import("../rubcycle/ja/index"),
    meta: {
      title: "ごみの分別",
    },
  },
  {
    path: "/rubcycleJA/detail",
    name: "rubcycleJAdetail",
    component: () => import("../rubcycle/ja/detail"),
    meta: {
      title: "ごみの分別",
    },
  },

  {
    path: "/rubcycleKO/main",
    name: "rubcycleKOmain",
    component: () => import("../rubcycle/ko/main"),
    meta: {
      title: "쓰레기 분류",
    },
  },
  {
    path: "/rubcycleKO/index",
    name: "rubcycleKO",
    component: () => import("../rubcycle/ko/index"),
    meta: {
      title: "쓰레기 분류",
    },
  },
  {
    path: "/rubcycleKO/detail",
    name: "rubcycleKOdetail",
    component: () => import("../rubcycle/ko/detail"),
    meta: {
      title: "쓰레기 분류",
    },
  },
];
const media = [
  {
    path: "/article/test",
    name: "articletest",
    component: () => import("../article/test"),
    meta: {
      title: "",
    },
  },
  {
    path: "/article/index",
    name: "article",
    component: () => import("../article/index"),
    meta: {
      title: "",
    },
  },
  {
    path: "/article/live",
    name: "live",
    component: () => import("../article/live"),
    meta: {
      title: "",
    },
  },
  {
    path: "/article/newlive",
    name: "newlive",
    component: () => import("../article/newlive"),
    meta: {
      title: "",
    },
  },
  {
    path: "/article/special",
    name: "special",
    component: () => import("../article/special"),
    meta: {
      title: "苏周到专题",
      keepAlive: true,
    },
  },
  {
    path: "/article/hot",
    name: "articlehot",
    component: () => import("../article/hot"),
    meta: {
      title: "苏州热视频",
      keepAlive: true,
    },
  },
  // {
  //   path: "/article/imageAndText",
  //   name: "article-imageAndText",
  //   component: () => import("../article/imageAndText2"),
  //   meta: {
  //     title: "",
  //   },
  // },
  {
    path: "/article/conversion",
    name: "article-conversion",
    component: () => import("../article/conversion"),
    meta: {
      title: "",
    },
  },
  {
    path: "/article/imageList",
    name: "article-imageList",
    component: () => import("../article/imageList"),
    meta: {
      title: "",
    },
  },
  {
    path: "/article/video",
    name: "article-video",
    component: () => import("../article/video"),
    meta: {
      title: "",
    },
  },
];
const reflect = [
  {
    path: "/reflect/index",
    name: "reflect",
    component: () => import("../reflect/index"),
    meta: {
      title: "12345",
    },
  },
  {
    path: "/movecar",
    name: "movecar",
    component: () => import("../movecar/index"),
    meta: {
      title: "自助挪车",
    },
    children: [
      {
        path: "",
        name: "",
        component: () => import("../movecar/add"),
        meta: {
          title: "自助挪车",
          background: "gray",
        },
      },
      {
        path: "/movecar/list",
        name: "movecarList",
        component: () => import("../movecar/list"),
        meta: {
          title: "挪车记录",
          background: "gray",
        },
      },
    ],
  },
  {
    path: "/movecar/detail",
    name: "movecardetail",
    component: () => import("../movecar/detail"),
    meta: {
      title: "挪车记录",
      background: "gray",
    },
  },
  {
    path: "/movecar/identify",
    name: "movecaridentify",
    component: () => import("../movecar/identify"),
    meta: {
      title: "识别结果",
      background: "gray",
    },
  },
  {
    path: "/reflect/list",
    name: "reflectlist",
    component: () => import("../reflect/list"),
    meta: {
      title: "我的诉求",
    },
  },
  {
    path: "/reflect/detail",
    name: "reflectdetail",
    component: () => import("../reflect/detail"),
    meta: {
      title: "我的诉求",
    },
  },
  {
    path: "/reflect/main",
    name: "reflectmain",
    component: () => import("../reflect/main"),
    meta: {
      title: "12345",
    },
  },
];
const error = [
  {
    path: "/error/nodata",
    name: "nodata",
    component: () => import("../error/nodata"),
  },
  {
    path: "/error/nonetwork",
    name: "nonetwork",
    component: () => import("../error/nonetwork"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../error/404"),
  },
  {
    path: "/300",
    name: "300",
    component: () => import("../error/300"),
    meta: {
      title: "维护页",
    },
  },
  {
    path: "/pulloff",
    name: "pulloff",
    component: () => import("../error/pulloff"),
  },
];
const newGas = [
  {
    path: "/gas/pay",
    name: "gas-pay",
    component: () => import("../newGas/index"),
    meta: {
      title: "苏州燃气缴费",
    },
  },
  {
    path: "/gas/add",
    name: "gas-add",
    component: () => import("../newGas/add"),
    meta: {
      title: "新增缴费账户",
    },
  },
  {
    path: "/gas/company",
    name: "gas-company",
    component: () => import("../newGas/company"),
    meta: {
      title: "选择缴费单位",
    },
  },
  {
    path: "/gas/group",
    name: "gas-group",
    component: () => import("../newGas/group"),
    meta: {
      title: "选择分组",
    },
  },
  {
    path: "/water/pay",
    name: "water-pay",
    component: () => import("../newWater/index"),
    meta: {
      title: "苏州自来水缴费",
    },
  },
  {
    path: "/water/add",
    name: "water-add",
    component: () => import("../newWater/add"),
    meta: {
      title: "新增缴费账户",
    },
  },
  {
    path: "/water/company",
    name: "water-company",
    component: () => import("../newWater/company"),
    meta: {
      title: "选择缴费单位",
    },
  },
  {
    path: "/water/group",
    name: "water-group",
    component: () => import("../newWater/group"),
    meta: {
      title: "选择分组",
    },
  },
  {
    path: "/electricity/pay",
    name: "electricity-pay",
    component: () => import("../newElectricity/index"),
    meta: {
      title: "苏州电力缴费",
    },
  },
  {
    path: "/electricity/add",
    name: "electricity-add",
    component: () => import("../newElectricity/add"),
    meta: {
      title: "新增缴费账户",
    },
  },
  {
    path: "/electricity/company",
    name: "electricity-company",
    component: () => import("../newElectricity/company"),
    meta: {
      title: "选择缴费单位",
    },
  },
  {
    path: "/electricity/group",
    name: "electricity-group",
    component: () => import("../newElectricity/group"),
    meta: {
      title: "选择分组",
    },
  },
  {
    path: "/cable/pay",
    name: "cable-pay",
    component: () => import("../newCable/index"),
    meta: {
      title: "苏州有线电视缴费",
    },
  },
  {
    path: "/cable/add",
    name: "cable-add",
    component: () => import("../newCable/add"),
    meta: {
      title: "新增缴费账户",
    },
  },
  {
    path: "/cable/company",
    name: "cable-company",
    component: () => import("../newCable/company"),
    meta: {
      title: "选择缴费单位",
    },
  },
  {
    path: "/cable/group",
    name: "cable-group",
    component: () => import("../newCable/group"),
    meta: {
      title: "选择分组",
    },
  },
];
const house = [
  {
    path: "/house",
    name: "house",
    component: () => import("../house/index"),
    meta: {
      title: "不动产证明",
    },
  },
  {
    path: "/choosehouse",
    name: "choosehouse",
    component: () => import("../house/choose"),
    meta: {
      title: "选择不动产",
      background: "gray",
    },
  },
  {
    path: "/houseresult",
    name: "houseresult",
    component: () => import("../house/result"),
    meta: {
      title: "不动产证明",
      background: "gray",
    },
  },
  {
    path: "/house/examine",
    name: "houseexamine",
    component: () => import("../house/examine"),
    meta: {
      title: "不动产权证核验",
      background: "gray",
    },
  },
  {
    path: "/house/examineresult",
    name: "houseexamineresult",
    component: () => import("../house/examineResult"),
    meta: {
      title: "不动产权证核验",
    },
  },
];

const house2 = [
  {
    path: "/house2",
    name: "house2",
    component: () => import("../house2/index"),
    meta: {
      title: "不动产证明",
    },
  },
  {
    path: "/choosehouse2",
    name: "choosehouse2",
    component: () => import("../house2/choose"),
    meta: {
      title: "选择不动产",
      background: "gray",
    },
  },
  {
    path: "/houseresult2",
    name: "houseresult2",
    component: () => import("../house2/result"),
    meta: {
      title: "不动产证明",
      background: "gray",
    },
  },
];

const lottery = [
  {
    path: "/lottery/jifen",
    name: "lotteryJifen",
    component: () => import("../lottery/Jifen/IndexNew10.vue"),
    meta: {
      title: "积分抽奖",
    },
  },
  {
    path: "/lottery/jifen/history",
    name: "lotteryJifenHistory",
    component: () => import("../lottery/Jifen/History.vue"),
    meta: {
      title: "中奖记录",
    },
  },
  {
    path: "/lottery/jifen/address",
    name: "lotteryJifenAddress",
    component: () => import("../lottery/Jifen/Address.vue"),
    meta: {
      title: "收货地址",
    },
  },
];

const emergency = [
  {
    path: "/emergency/index",
    name: "emergency",
    component: () => import("../emergency/index.vue"),
    meta: {
      title: "苏周到",
    },
    path: "/emergency/skm",
    name: "emergencySKM",
    component: () => import("../emergency/healthCode.vue"),
    meta: {
      title: "苏康码",
    },
  },
];

const digatlclassroom = [
  {
    path: "/digtalclassroom",
    name: "digtalClassroom",
    component: () => import("../digitalClassroom/index.vue"),
    meta: {
      title: "数字课堂",
    },
  },
  {
    path: "/digtaldetail",
    name: "digtalDetail",
    component: () => import("../digitalClassroom/detail.vue"),
    meta: {
      title: "数字课堂详情",
    },
  },
];

const digtalmoney = [
  {
    path: "/digtalmoney",
    name: "digtalmoney",
    component: () => import("../digtalmoney/index.vue"),
    meta: {
      title: "疫情防控 有奖答题",
    },
  },
  {
    path: "/digtalmoneyQuestion",
    name: "digtalmoneyQuestion",
    component: () => import("../digtalmoney/question.vue"),
    meta: {
      title: "疫情防控 有奖答题",
    },
  },
  {
    path: "/answerWrong",
    name: "answerWrong",
    component: () => import("../digtalmoney/answerWrong.vue"),
    meta: {
      title: "答题结果",
    },
  },
  {
    path: "/answerRight",
    name: "answerRight",
    component: () => import("../digtalmoney/answerRight.vue"),
    meta: {
      title: "答题结果",
    },
  },
  {
    path: "/signupSuccess",
    name: "signupSuccess",
    component: () => import("../digtalmoney/signupSuccess.vue"),
    meta: {
      title: "提交结果",
    },
  },
  {
    path: "/digtalmoney/readme",
    name: "digtalmoneyReadme",
    component: () => import("../digtalmoney/readme.vue"),
    meta: {
      title: "操作指引",
    },
  },
  {
    path: "/digtalmoney/sign",
    name: "digtalmoney-sign",
    component: () => import("../digtalmoney/sign1.vue"),
    meta: {
      title: "疫情防控 有奖答题",
    },
  },
];

const society = [
  {
    path: "/society",
    name: "society",
    component: () => import("../society/index"),
    meta: {
      title: " ",
    },
  },
  {
    path: "/society/list",
    name: "societylist",
    component: () => import("../society/list"),
    meta: {
      title: "智慧人社",
    },
  },
];
const oneYearVote = [
  {
    path: "/oneYearVote",
    name: "oneYearVote",
    component: () => import("../oneYearVote/vote"),
    meta: {
      title: "2021年苏周到“最受欢迎服务”评选",
    },
  },
  {
    path: "/oneYearVote1",
    name: "oneYearVote1",
    component: () => import("../oneYearVote/vote1"),
    meta: {
      title: "2021年苏周到“最受欢迎服务”评选",
    },
  },
];
const service = [
  {
    path: "/service/explain",
    name: "societyexplain",
    component: () => import("../service/explain"),
    meta: {
      title: "使用说明",
    },
  },
  {
    path: "/service/help",
    name: "societyhelp",
    component: () => import("../service/help"),
    meta: {
      title: "添加到桌面",
    },
  },
  {
    path: "/service/videoDetail",
    name: "serviceVideoDetail",
    component: () => import("../service/videoDetail"),
    meta: {
      title: "服务视频",
    },
  },
];
const card = [
  {
    path: "/card",
    name: "card",
    component: () => import("../card/index"),
    meta: {
      title: "集周年卡 赢周边礼",
    },
  },
  {
    path: "/card/address",
    name: "cardaddress",
    component: () => import("../card/address"),
    meta: {
      title: "集周年卡 赢周边礼",
    },
  },
  {
    path: "/card/result",
    name: "cardresult",
    component: () => import("../card/result"),
    meta: {
      title: "集周年卡 赢周边礼",
    },
  },
  {
    path: "/card/role",
    name: "cardrrole",
    component: () => import("../card/role"),
    meta: {
      title: "活动规则",
    },
  },
];
const publicservice = [
  {
    path: "/publicservice/index",
    name: "publicservice",
    component: () => import("../publicservice/index"),
    meta: {
      title: "我为群众办实事",
    },
  },
  {
    path: "/publicservice/familyList",
    name: "familyList",
    component: () => import("../publicservice/familyList"),
    meta: {
      title: "“三全”社区家庭教育",
    },
  },
  {
    path: "/publicservice/helplist",
    name: "helplist",
    component: () => import("../publicservice/helplist"),
    meta: {
      title: "困境妇女儿童援助帮扶",
    },
  },
  {
    path: "/publicservice/publicmind",
    name: "publicmind",
    component: () => import("../publicservice/publicmind"),
    meta: {
      title: "妇女儿童家庭关爱公益项目",
    },
  },
  {
    path: "/publicservice/couplehelp",
    name: "couplehelp",
    component: () => import("../publicservice/couplehelp"),
    meta: {
      title: "“一对一”结对帮扶",
    },
  },
  {
    path: "/publicservice/servicecenter",
    name: "servicecenter",
    component: () => import("../publicservice/servicecenter"),
    meta: {
      title: "公益心理咨询",
    },
  },
];
const backToSzRegister = [
  {
    path: "/tosz/backToSzIndex",
    name: "backToSzIndex",
    component: () => import("../tosz/backToSzIndex"),
    meta: {
      title: "来（返）苏州信息登记",
    },
  },
  {
    path: "/tosz/backToSz-apply",
    name: "backToSz-apply",
    component: () => import("../tosz/backToSz-apply"),
    meta: {
      title: "来（返）苏州信息登记",
    },
  },
  {
    path: "/tosz/backToSz-apply-fromJS",
    name: "backToSz-apply-fromJS",
    component: () => import("../tosz/backToSz-apply-fromJS"),
    meta: {
      title: "来（返）苏州信息登记",
    },
  },
  {
    path: "/tosz/backToSz-apply-fromSH",
    name: "backToSz-apply-fromSH",
    component: () => import("../tosz/backToSz-apply-fromSH"),
    meta: {
      title: "来（返）苏州信息登记",
    },
  },
  {
    path: "/tosz/backToSz-apply-detail",
    name: "backToSz-apply-detail",
    component: () => import("../tosz/backToSz-apply-detail"),
    meta: {
      title: "信息登记记录",
    },
  },
  {
    path: "/tosz/main",
    name: "backToSz-apply-h5-login",
    component: () => import("../tosz/backToSz-apply-h5-login"),
    meta: {
      title: "来（返）苏州信息登记",
    },
  },
  {
    path: "/tosz/other-browser",
    name: "other-browser",
    component: () => import("../tosz/other-browser"),
    meta: {
      title: "来（返）苏州信息登记",
    },
  },
  {
    path: "/codeSwitch/index",
    name: "codeSwitchIndex",
    component: () => import("../skmytog/index"),
    meta: {
      title: "苏康码转码申请",
    },
  },
  {
    path: "/codeSwitch/apply",
    name: "codeSwitchApply",
    component: () => import("../skmytog/apply"),
    meta: {
      title: "苏康码转码申请",
    },
  },
  {
    path: "/codeSwitch/apply2",
    name: "codeSwitchApply2",
    component: () => import("../skmytog/apply2"),
    meta: {
      title: "苏康码转码申请",
    },
  },
  {
    path: "/codeSwitch/record",
    name: "codeSwitchRecord",
    component: () => import("../skmytog/record"),
    meta: {
      title: "申请记录",
    },
  },
];

const reside = [
  {
    path: "/residepermit",
    name: "residepermit",
    component: () => import("../residepermit/index"),
    meta: {
      title: "居住证签注打卡",
    },
  },
  {
    path: "/residepermit/scan",
    name: "residepermitScan",
    component: () => import("../residepermit/scan"),
    meta: {
      title: "居住证签注打卡",
    },
  },
  {
    path: "/residepermit/result",
    name: "residepermitResult",
    component: () => import("../residepermit/result"),
    meta: {
      title: "居住证签注打卡",
    },
  },
  {
    path: "/residepermit/record",
    name: "residepermitRecord",
    component: () => import("../residepermit/record"),
    meta: {
      title: "签注打卡记录",
      background: "gray",
    },
  },
];

const political = [
  {
    path: "/political",
    name: "political",
    component: () => import("../political/index"),
    meta: {
      title: "党建引领",
    },
  },
  {
    path: "/political/list",
    name: "political-list",
    component: () => import("../political/list"),
    meta: {
      title: "党员在线教育",
    },
  },
];

const epidemic = [
  {
    path: "/epidemic",
    name: "epidemic",
    component: () => import("../epidemic/index"),
    meta: {
      title: "防疫服务",
    },
  },
];

const marriage = [
  {
    path: "/marriage",
    name: "marriage",
    component: () => import("../marriage/index"),
    meta: {
      title: "婚姻一件事",
    },
  },
  {
    path: "/marriage/add",
    name: "marriage-add",
    component: () => import("../marriage/add"),
    meta: {
      title: "证照信息纠错",
      background: "gray",
    },
  },
  {
    path: "/marriage/process",
    name: "marriage-process",
    component: () => import("../marriage/process"),
    meta: {
      title: "办理进度查询",
      background: "gray",
    },
  },
  {
    path: "/marriage/result",
    name: "marriage-result",
    component: () => import("../marriage/result"),
    meta: {
      title: "办理进度查询",
    },
  },
];

const specialareaservice = [
  {
    path: "/specialareaservice",
    name: "specialareaservice",
    component: () => import("../specialareaservice/index"),
  },
];

const newstudent = [
  {
    path: "/newStudent",
    name: "newStudent",
    component: () => import("../newstudent/index"),
    meta: {
      title: "高校新生礼包",
    },
  },
  {
    path: "/newStudent/single",
    name: "newStudent-single",
    component: () => import("../newstudent/single"),
    meta: {
      title: " ",
    },
  },
  {
    path: "/newStudent/multiple",
    name: "newStudent-multiple",
    component: () => import("../newstudent/multiple"),
    meta: {
      title: " ",
    },
  },
  {
    path: "/newStudent/figuremoney",
    name: "newStudent-figuremoney",
    component: () => import("../newstudent/figuremoney"),
    meta: {
      title: "数字人民币红包使用说明",
    },
  },
  {
    path: "/newStudent/callcoupon",
    name: "newStudent-callcoupon",
    component: () => import("../newstudent/callcoupon"),
    meta: {
      title: "通讯数据优惠包政策说明",
    },
  },
];

const nuclearCode = [
  {
    path: "/nuclearCode",
    name: "nuclearCode",
    component: () => import("../nuclearCode/index"),
    meta: {
      title: "核酸检测身份码",
    },
  },
  {
    path: "/nuclearList",
    name: "nuclearList",
    component: () => import("../nuclearCode/list"),
    meta: {
      title: "核酸码申领列表",
    },
  },
  {
    path: "/nuclearApply",
    name: "nuclearApply",
    component: () => import("../nuclearCode/apply"),
    meta: {
      title: "申请核酸码",
    },
  },
  {
    path: "/webviewTest",
    name: "webviewTest",
    component: () => import("../webviewTest/index"),
    meta: {
      title: "webviewTest",
    },
  },
];

const feverConsult = [
  {
    path: "/feverconsult/user",
    name: "feverconsult-user",
    component: () => import("../feverConsult/user"),
    meta: {
      title: "发热咨询",
    },
  },
  {
    path: "/feverconsult/doctor",
    name: "feverconsult-doctor",
    component: () => import("../feverConsult/doctor"),
    meta: {
      title: "发热咨询（医生端）",
    },
  },
  {
    path: "/feverconsult/login",
    name: "feverconsult-login",
    component: () => import("../feverConsult/login"),
    meta: {
      title: "发热咨询",
      keepAlive: true,
    },
  },
];

const oneaffair = [
  {
    path: "/oneaffair",
    name: "oneaffair",
    component: () => import("../oneaffair/index2"),
    meta: {
      title: "一件事专区",
    },
  },
];

const zhouzhi = [
  {
    path: "/content/news",
    name: "ContentNews",
    component: () => import("../content/news/News.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/news_min",
    name: "ContentNewsMin",
    component: () => import("../content/news/NewsMin.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/topic/style1",
    name: "ContentTopicStyle1Index",
    component: () => import("../content/topic/Style1Index.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/topic/style1/list",
    name: "ContentTopicStyle1List",
    component: () => import("../content/topic/Style1List.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/topic/styleMatch",
    name: "ContentTopicStyleMatch",
    component: () => import("../content/topic/StyleMatch.vue"),
    meta: {
      title: "",
    },
  },
  //反诈答题
  {
    path: "/content/topic/fanzhaAnswer",
    name: "fanzhaAnswer",
    component: () => import("../content/topic/fanzhaAnswer/index.vue"),
    meta: {
      title: "反诈知识问答",
    },
  },
  {
    path: "/content/topic/fanzhaAnswer/answer",
    name: "fanzhaAnswerlist",
    component: () => import("../content/topic/fanzhaAnswer/answer.vue"),
    meta: {
      title: "反诈知识问答",
    },
  },
  {
    path: "/content/topic/fanzhaAnswer/ansResult",
    name: "fanzhaAnswerResult",
    component: () => import("../content/topic/fanzhaAnswer/ansResult.vue"),
    meta: {
      title: "反诈知识问答",
    },
  },
  {
    path: "/content/topic/fanzhaAnswer/lottory",
    name: "fanzhaAnswerlottory",
    component: () => import("../content/topic/fanzhaAnswer/lottory.vue"),
    meta: {
      title: "反诈知识问答",
    },
  },
  //反诈宣传
  {
    path: "/content/topic/styleFanzha",
    name: "ContentTopicStyleFanzha",
    component: () => import("../content/topic/StyleFanzha/index.vue"),
    meta: {
      title: "反诈知识问答",
    },
  },
  {
    path: "/content/topic/styleFanzha/vdlist",
    name: "ContentTopicStyleFanzhavd",
    component: () => import("../content/topic/StyleFanzha/vdlist.vue"),
    meta: {
      title: "反诈知识问答",
    },
  },
  {
    path: "/content/topic/styleFanzha/gjlist",
    name: "ContentTopicStyleFanzhagl",
    component: () => import("../content/topic/StyleFanzha/gjlist.vue"),
    meta: {
      title: "反诈知识问答",
    },
  },
  {
    path: "/content/topic/styleMeeting",
    name: "ContentTopicStyleMeeting",
    component: () => import("../content/topic/StyleMeeting.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/topic/styleTeeth",
    name: "ContentTopicStyleTeeth",
    component: () => import("../content/topic/StyleTeeth.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/topic/styleForum",
    name: "ContentTopicStyleForum",
    component: () => import("../content/topic/StyleForum.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/topic/styleAirline",
    name: "ContentTopicStyleAirline",
    component: () => import("../content/topic/StyleAirline.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/topic/styleMatch/marathon/readme",
    name: "ContentTopicStyleMatchMarathonIntro",
    component: () =>
      import("../content/topic/StyleMatchComponent/MarathonIntroduce.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/topic/new-year",
    name: "ContentTopicNewYear",
    component: () => import("../content/topic/NewYear.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/gallery",
    name: "ContentGallery",
    component: () => import("../content/gallery/Index.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/vod",
    name: "ContentVod",
    component: () => import("../content/vod/Index.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/vodCustom",
    name: "ContentVodCustom",
    component: () => import("../content/vod/customIndex.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/audio/detail",
    name: "ContentAudioDetail",
    component: () => import("../content/audio/Detail.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/fmalbum",
    name: "ContentFMAlbum",
    component: () => import("../content/fmalbum/index.vue"),
    meta: {
      title: "5G智慧电台",
    },
  },
  {
    path: "/content/fmalbum/album",
    name: "ContentFMAlbumDetail",
    component: () => import("../content/fmalbum/album.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/channel/share",
    name: "ChannelShare",
    component: () => import("../content/channel/Share.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/subscribe/list",
    name: "SubscribeList",
    component: () => import("../content/subscribe/List.vue"),
    meta: {
      title: "周到号",
    },
  },
  {
    path: "/content/subscribe/detail",
    name: "SubscribeDetail",
    component: () => import("../content/subscribe/Detail.vue"),
    meta: {
      title: "周到号",
    },
  },
  {
    path: "/content/picture",
    name: "PictureDetail",
    component: () => import("../content/Picture.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/tvplay/index",
    name: "TVPlay",
    component: () => import("../content/tvplay/index.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/tvplay2/index",
    name: "TVPlay2",
    component: () => import("../content/tvplay2/index.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/content/tvplay/index1",
    name: "TVPlay3",
    component: () => import("../content/tvplay/index1.vue"),
    meta: {
      title: "",
    },
  },
  // 五卅专题
  {
    path: "/content/ideology/index",
    name: "Ideology",
    component: () => import("../content/ideology/index.vue"),
    meta: {
      title: "",
    },
  },
  // 老虎征名
  {
    path: "/content/animal/index",
    name: "Animal",
    component: () => import("../content/animal/index.vue"),
    meta: {
      title: "",
    },
  },
  // 老虎证明列表
  {
    path: "/content/animal/list",
    name: "AnimalTopicList",
    component: () => import("../content/animal/list.vue"),
    meta: {
      title: "",
    },
  },
];

const livesz = [
  {
    path: "/livesz/index",
    name: "LiveszIndex",
    component: () => import("../livesz/main.vue"),
    meta: {
      title: "直播苏州",
    },
  },
  {
    path: "/livesz/main",
    name: "LiveszMain",
    component: () => import("../livesz/main.vue"),
    meta: {
      title: "直播苏州",
      keepAlive: true,
    },
  },
  {
    path: "/livesz/home",
    name: "LiveszHome",
    component: () => import("../livesz/index.vue"),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/livesz/list",
    name: "LiveszList",
    component: () => import("../livesz/list.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/livesz/report",
    name: "LiveszReport",
    component: () => import("../livesz/report.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/livesz/signin",
    name: "LiveszSignin",
    component: () => import("../livesz/signin.vue"),
    meta: {
      title: "每日签到",
    },
  },
  {
    path: "/livesz/lotteryResult",
    name: "LiveszLotteryResult",
    component: () => import("../livesz/lotteryResult.vue"),
    meta: {
      title: "中奖结果",
    },
  },
  {
    path: "/pdfShow/index",
    name: "pdfShow",
    component: () => import("../pdfShow/index.vue"),
    meta: {
      title: "中奖结果",
    },
  },
];

// 办事模块改版（全部服务）
const allserivces = [
  {
    path: "/allserivces",
    name: "allserivces",
    component: () => import("../all-services/index"),
    meta: {
      title: "办事模块",
    },
  },
  {
    path: "/serivce/reservation",
    name: "reservation",
    component: () => import("../all-services/reservation"),
    meta: {
      title: "在线预约",
    },
  },
];
const routes = [].concat(
  acfund,
  publicservice,
  progress,
  my,
  zh,
  rs,
  edu,
  gongan,
  gongyi,
  other,
  entr,
  rubbish,
  canlian,
  error,
  media,
  newGas,
  reflect,
  house,
  house2,
  lottery,
  emergency,
  digatlclassroom,
  digtalmoney,
  society,
  oneYearVote,
  service,
  card,
  backToSzRegister,
  reside,
  political,
  epidemic,
  marriage,
  specialareaservice,
  newstudent,
  nuclearCode,
  feverConsult,
  oneaffair,
  zhouzhi,
  livesz,
  allserivces
);

const router = new VueRouter({
  routes,
  scrollBehavior: () => ({
    y: 0,
  }), //路由跳转后页面回到顶部
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  /* 局部切换页面灰底 */
  if (to.meta.background === "gray") {
    document.querySelector("body").setAttribute("style", "background: #f7f7f7");
  } else {
    document.querySelector("body").setAttribute("style", "background: #ffffff");
  }

  store.commit("setRouteFrom", from);
  store.commit("setRouteTo", to);

  next();
});
// router.afterEach((to, from, next) => {
//   window.scrollTo(0, 0);
// });

export default router;
